/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const RestoreCluster = {
  id: 'cluster-restore.post',
  tag: 'Cluster',
  summary: 'Restore a cluster to a specific point in time',
  description: 'Restore a cluster to a specific point in time within an organization project',
  method: 'post',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/restore`,
  request: {
    params: Params,
    body: {
      required: true,
      content: {
        'application/json': {
          schema: z.strictObject({
            timestamp: ZodTypes.Timestamp,
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
